<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <v-sheet class="w-full code-flex">
        <i-card-vertical class="pr-3 w-hfull" headerTitle="주문 정보" device="web">
          <template v-slot:body>
            <v-card width="100%" height="100%">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="cancel-request-text-card pa-2 mb-2" outlined elevation="0">
                    <v-card-text class="cancel-request-text-card-body">
                      <div class="form-label card-label">고객사명</div>
                      <div class="cancel-request-text">
                        {{ propsData.clntNm }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>              
              <!-- 승인 전: 기존 결제 계산 -->
                <calcPaymentAmount
                  v-if="propsData.cancelStatus === 'N'"
                  :uniqueKey="propsData.orderId"
                  :type="'PAY'"
                  :startDate="propsData.constructDtS"
                  :endDate="propsData.constructDtE"
                  :feeCd="propsData.feeCd"
                  :isPromotion="propsData.feeType === 'promotion'"
                  :propsData="propsData"
                />
                <!-- 승인 완료: 저장된 결제 결과 -->
                <paymentSummary
                  v-if="propsData.cancelStatus === 'A'"
                  :uniqueKey="propsData.orderId"
                  :type="'PAY'"
                  :startDate="propsData.constructDtS"
                  :endDate="propsData.constructDtE"
                  :feeCd="propsData.feeCd"
                  :isPromotion="propsData.feeType === 'promotion'"
                  :propsData="propsData"
                />
            </v-card>
          </template>
        </i-card-vertical>
        <!-- 적용중인 요금제가 없을 경우-->
        <i-card-vertical class="w-hfull" headerTitle="해지 정보" device="web">
          <template v-slot:body>
            <!-- cancelPopup.vue 파일 css 동일하게 적용 필요 -->
            <v-card width="100%" height="100%">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="cancel-request-text-card pa-2 mb-2" outlined elevation="0">
                    <v-card-text class="cancel-request-text-card-body">
                      <div class="form-label card-label">해지 요청일</div>
                      <div class="cancel-request-text">
                        {{ propsData.cancelRequestAt }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <!-- 승인 전: 기존 환불 계산 -->
                <calcCancelAmount
                  v-if="propsData.cancelStatus === 'N'"
                  ref="cca"
                  :orderId="propsData.orderId"
                  :isPromotion="propsData.feeType === 'promotion'"
                  :propsData="propsData"
                  @done="syncRefundAmount"
                />

                <!-- 승인 완료: 저장된 환불 결과 -->
                <cancelSummary 
                  v-else-if="propsData.cancelStatus === 'A'"
                  ref="cancelSummary" 
                  :orderId="propsData.orderId" 
                  :isPromotion="propsData.feeType === 'promotion'" 
                  :propsData="propsData" 
                />
              </v-row>
              <v-divider style="margin: 16px 0"></v-divider>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="cancel-request-text-card pa-2 mb-2" outlined elevation="0">
                    <v-card-text class="cancel-request-text-card-body">
                      <div class="form-label card-label">해지 사유</div>
                      <div class="cancel-request-text">
                        {{ propsData.cancelReason }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h5>환불 이체 정보</h5>
                </v-col>
              </v-row>
              <v-form ref="refundForm">
                <v-row no-gutters class="d-flex justify-space-between">
                  <v-col cols="4">
                    <v-card class="cancel-request-text-card pa-2 mb-2" outlined elevation="0">
                      <v-card-text class="cancel-request-text-card-body">
                        <div class="form-label card-label">이체 은행</div>
                        <div class="cancel-request-text">
                          {{ propsData.refundBank }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card class="cancel-request-text-card pa-2 mb-2" outlined elevation="0">
                      <v-card-text class="cancel-request-text-card-body">
                        <div class="form-label card-label">예금주</div>
                        <div class="cancel-request-text">
                          {{ propsData.refundAccountHolder }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="4">
                    <v-card class="cancel-request-text-card pa-2 mb-2" outlined elevation="0">
                      <v-card-text class="cancel-request-text-card-body">
                        <div class="form-label card-label">계좌 번호</div>
                        <div class="cancel-request-text">
                          {{ propsData.refundAccountNumber }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="form-label required">이체 금액</div>
                    <v-text-field
                    class="editor_bg right-input"
                    :value="refundAmountString"
                    solo
                    hide-details="auto"
                    :rules="[rules.required]"
                    suffix="원"
                    :disabled="propsData.cancelStatus === 'A'"
                    @input="inputFormatToKoreanWon($event)"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </template>
        </i-card-vertical>
      </v-sheet>
      <i-card-right headerTitle :useBtnList="buttonUseList">
        <template v-slot:body>
          <v-layout>
            <v-row no-gutters class="pa-0 pt-2">
              <v-col cols="12" md="4"></v-col>
            </v-row>
          </v-layout>
        </template>
        <template v-slot:customBtn>
          <i-icon-button
            color="btn_text"
            :text="'목록으로'"
            height="92px"
            :icon="'back'"
            :appendDivider="propsData.cancelStatus === 'N' ? true : false"
            @click="btnCancel()"
          ></i-icon-button>
          <i-icon-button
            v-if="propsData.cancelStatus === 'N'"
            color="btn_text"
            :text="'승인'"
            height="92px"
            :icon="'check'"
            :appendDivider="false"
            @click="btnApprove()"
          />
        </template>
      </i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
// 컴포넌트
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import iCardVertical from '@/components/common/iCardVertical.vue'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import paymentSummary from './PaymentSummary.vue'
import cancelSummary from './CancelSummary.vue'
import calcPaymentAmount from '@/payment/components/calcPaymentAmount.vue'
import calcCancelAmount from '@/payment/components/calcCancelAmount.vue'

// 유틸
import { getDateDiff } from '@/utils/common.js'

// API
import { getCustomerLoginHistoryAferPayment, approveCancel } from '@/payment/api/toss'

export default {
  mixins: [baseview], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'i-card-vertical': iCardVertical,
    paymentSummary,
    cancelSummary,
    calcPaymentAmount,
    calcCancelAmount,
  },

  data() {
    return {
      propsData: {},
      buttonUseList: ['btnApprove'],
      numFormat: /^\d{1,3}(,\d{3})*(\.\d+)?$/,
      rules: {
        required: (value) => !!value || '필수입력 값입니다.',
        numCheck: (value) => !(value != null && value != '' && value.match(this.numFormat) == null) || this.$t('올바르지 않은 형식입니다.'),
      },
      refundAmountString: '', // 환불 금액 출력용 변수
      remark: '',
      customerLoginDate: null,
      refundAmount: 0,
    }
  },
  watch: {
    propsData: {
      deep: true,
      handler() {
        // 사용 기간
        //this.calcRefund()
        // this.refundAmount = this.$refs.cca.getAmount(true) ? this.$refs.cca.getAmount(true) : 0
        this.refundAmountString = String(this.refundAmount)
      },
    },
  },
  created() {},
  beforeMount() {},
  unmounted() {
    this.refundAmount = 0
    this.refundAmountString = ''
    this.propsData = {}
  },
  mounted() {
    // activated를 안탈때, 처음 페이지에 들어왔을 때 초기화를 위해 한번더 넣어줌
    this.refundAmount = 0
    this.refundAmountString = ''
  },
  activated() {
    // 금액 초기화
    this.refundAmount = 0
    this.refundAmountString = ''
    if (this.$route.params.data) {
      this.propsData = this.$route.params.data
      this.btnSearch(true)
    } else {
      const toRouter = {
        name: 'CancelManage',
        params: {},
      }
      this.$router.push(toRouter)
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      if (date.indexOf('-') == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}.${month}.${day}`
      } else if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    formatToKoreanWon(value) {
      // 문자열을 입력 받아 한국 원단위로 치환한다.
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      }
    },
    inputFormatToKoreanWon(e) {
      this.refundAmount = e.replaceAll(',', '')
      this.refundAmountString = this.formatToKoreanWon(e)
    },
    syncRefundAmount() {
      const amount = this.$refs.cca?.getAmount() ?? 0

      this.refundAmount = amount
      this.refundAmountString = this.formatToKoreanWon(String(amount))
    },
    // 버튼 이벤트
   btnSearch(notify) {
      this.$nextTick(() => {
        if (this.propsData.cancelStatus === 'N' && this.$refs.cca) {
          this.$refs.cca.btnSearch()
        }
      })
    },
    btnCancel() {
      this.vToastifyPrompt(this.$t('이전 페이지로 이동하시겠습니까?'), 'info', async (current) => {
        this.toList()
      })
    },
    btnApprove() {
      // 환불 정보 계산 전에는 승인 불가
      if (this.$refs.cca?.done !== true) {
        this.vSnackbar('환불금액 조회가 완료된 후 승인해주세요.', 'warn', 3000)
        return
      }

      console.log('#### --- approve params --- ####')
      console.log(this.propsData)
      console.log('#### Refund Amount >> ', this.refundAmount)
      console.log('#### --- -------------- --- ####')
      if (!this.$refs.refundForm.validate()) {
        this.vSnackbar(this.$t('필수 입력 항목을 확인해주세요.'), 'warn', 3000)
        return
      }
      this.vToastifyPrompt(
        this.$t('해지를 승인 하시겠습니까?'),
        'info',
        async () => {
          const cancelParam = {
            clntId: this.propsData.clntId,
            compId: this.propsData.compId,
            orderId: this.propsData.orderId,
            orderDt: this.propsData.cancelRequestAt,
            orderType: 'AC',
            feeCd: this.propsData.feeCd,
            paymentAmount: this.refundAmount,
            cancelReason: this.propsData.cancelReason,
            paymentType: this.propsData.paymentType,
          }

          this.openLoading()
          approveCancel(cancelParam, true)
            .then((res) => {
              //
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
              this.toList()
            })
        },
        null,
        true
      )
    },
    toList() {
      const toRouter = {
        name: 'CancelManage',
        params: {
          data: { flag: true },
        },
      }
      this.$router.push(toRouter)
    },
  },
}
</script>

<style scoped>
.right-input >>> input {
  text-align: right;
}
.cancel-request-text-card {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.08) 100%);
  overflow: hidden;
}
.cancel-request-text-card-body {
  padding: 2px 2px;
}
.card-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}
</style>
